import { EMAIL_TYPE_DESCRIPTION_MAX_LENGTH } from "@/modules/email-types/constants";
import { ulid } from "@/schemas/commonFields";
import { z } from "@/zod";

export const emailTypeRole = z.object({
  id: ulid,
  code: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
});
export const displayEmailTypeRole = emailTypeRole.readonly();

export const readEmailType = z.object({
  id: ulid,
  code: z.string(),
  name: z.string(),
  description: z.string().max(EMAIL_TYPE_DESCRIPTION_MAX_LENGTH).nullable(),
  allowed_roles: z.array(emailTypeRole).default([]),
});

export const displayEmailType = readEmailType.readonly();
